import React from 'react';
import PropTypes from 'prop-types';
import { ToastContainer, Slide } from 'react-toastify';
import makeStyles from '@mui/styles/makeStyles';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function BaseLayout({ children }) {
  const classes = useStyles();
  return (
    <>
      {children}
      <ToastContainer
        className={classes.toastsContainer}
        transition={Slide}
        theme="colored"
        progressClassName={classes.toastProgressBar}
        bodyClassName={classes.toastBody}
        style={{ width: 380 }}
      />
    </>
  );
}

BaseLayout.propTypes = {
  children: PropTypes.node,
};

BaseLayout.defaultProps = {
  children: null,
};

export default BaseLayout;
